import React, { Component } from 'react'
import axios from 'axios'

import { Label } from '../../atoms/label'
import { Title } from '../../atoms/title'
import { Button } from '../../atoms/button'
import { Loader } from '../../atoms/loader'
import { Inputbox } from '../../atoms/inputbox'

import styles from '../../pages/auth/auth.module.css'

const LoginURL = 'https://us-central1-onlive-poker-dev.cloudfunctions.net/admin/login/'

export class PasswordReset extends Component {

    state = {
        error: null,
        loading: false,
        message: null,
    }

    onDetailChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    onResetPassword = () => {
        if ('email' in this.state && !!this.state.email) {
            if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.state.email)) {
                this.setState({ loading: true, error: null })
                axios.post(LoginURL + 'updatePassword', { "email": this.state.email })
                    .then(response => {
                        this.setState({ loading: false, message: response.data.message + '. Redirecting you to login page now.' })
                        window.setTimeout(this.props.toggleTemplate, 3000)
                    })
                    .catch(error => {
                        if ('response' in error && error.response && 'data' in error.response && error.response.data && 'message' in error.response.data) {
                            this.setState({ loading: false, error: error.response.data.message })
                        } else {
                            this.setState({ loading: false, error: "An error has occured." })
                        }
                    })
            } else {
                this.setState({ error: 'Please enter a valid email ID' })
            }
        } else {
            this.setState({ error: 'Please enter an email ID' })
        }
    }

    render() {
        return <div className={styles.templateContainer}>
            <div className={styles.header}>
                <Title bold>Reset Password</Title>
            </div>
            <div className={styles.body}>
                <Inputbox name="email" placeholder="Email ID" type="email" onChange={this.onDetailChange} />
                {this.state.message && <Label success center>{this.state.message}</Label>}
                {this.state.error && <Label error center>{this.state.error}</Label>}
                <Label info onClick={this.props.toggleTemplate}>Login page</Label>
                <Button primary submit onClick={this.onResetPassword}>Reset Password{this.state.loading && <Loader small />}</Button>
            </div>
        </div>
    }
}